var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScalelogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_921_5748)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M188.159 120.481H149.953L146.142 113.536L123.614 74.5429L89.5891 133.545H51.2571L123.614 8.17871L175.119 97.3153L188.159 120.481Z",
    fill: "url(#paint0_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.613 133.569V133.608H51.2812L61.7539 115.497L79.0774 85.512C78.4488 89.1874 78.1327 92.9094 78.1325 96.6383C78.109 109.83 82.1143 122.715 89.613 133.569Z",
    fill: "url(#paint1_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.444 153.656C219.444 160.294 219.216 167.2 219.074 173.956C219.444 209.965 174.191 249.698 123.41 249.674C78.6289 249.674 52.4154 228.162 36.6432 194.791C35.3834 192.177 34.2811 189.555 33.3047 186.877H39.1631H78.6841C82.7128 192.26 87.6764 196.874 93.338 200.5L93.9207 200.87L95.1018 201.586L96.0705 202.145L96.5035 202.382C97.0757 202.702 97.6559 203.009 98.2438 203.303L98.9681 203.665C111.966 210.044 126.943 211.09 140.702 206.579L141.788 206.209L142.773 205.846L143.749 205.476L143.993 205.382L144.41 205.216H144.489L144.914 205.043C156.124 200.313 165.486 192.059 171.585 181.531L171.718 181.294L171.97 180.854L172.214 180.413C172.435 180.003 172.656 179.625 172.876 179.176C173.401 178.21 173.873 177.226 174.293 176.223C174.435 175.908 174.569 175.586 174.703 175.271C174.908 174.788 175.104 174.302 175.293 173.814L27.3438 173.956V133.513H219.397L219.444 153.656Z",
    fill: "url(#paint2_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.348 173.814C172.253 206.296 133.858 240.289 89.0929 244.47C77.3526 240.327 66.6166 233.758 57.5836 225.19C48.5507 216.623 41.4236 206.249 36.6662 194.744C35.4142 192.145 34.3512 189.539 33.3433 186.87H39.1624C44.3819 192.438 50.6834 196.881 57.681 199.928C64.6785 202.975 72.2247 204.56 79.8566 204.587C85.363 204.596 90.8392 203.776 96.1011 202.154H96.172C108.651 209.198 123.371 211.146 137.253 207.591C151.136 204.035 163.106 195.251 170.662 183.074L170.938 182.633L171.135 182.31L171.6 181.523L171.734 181.287L171.985 180.846L172.229 180.405C172.45 179.995 172.671 179.583 172.891 179.169C173.416 178.203 173.888 177.218 174.308 176.216L174.718 175.263C174.962 174.791 175.151 174.302 175.348 173.814Z",
    fill: "url(#paint3_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.119 204.972C131.665 211.152 117.049 214.395 102.243 214.484C89.4508 215.163 76.6638 213.05 64.77 208.29C52.8762 203.531 42.1607 196.241 33.3674 186.924H78.7309C83.1729 192.863 88.7477 197.862 95.1331 201.634L96.1015 202.192L96.5348 202.437C97.107 202.757 97.6869 203.064 98.2748 203.358C104.953 206.773 112.257 208.791 119.74 209.291C127.224 209.79 134.731 208.76 141.804 206.264L142.788 205.901L143.764 205.531L144.009 205.437L144.426 205.271H144.505L144.93 205.098L145.119 204.972Z",
    fill: "url(#paint4_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.2892 173.9H38.3042H27.4221V144.451C27.4221 142.6 27.4221 140.947 27.4221 138.852C28.675 146.884 32.1293 154.411 37.4017 160.598C42.674 166.785 49.558 171.389 57.2892 173.9Z",
    fill: "url(#paint5_linear_921_5748)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.536 86.5905C146.537 86.5905 165.994 67.1337 165.994 43.1325C165.994 19.1313 146.537 -0.325562 122.536 -0.325562C98.5347 -0.325562 79.0779 19.1313 79.0779 43.1325C79.0779 67.1337 98.5347 86.5905 122.536 86.5905Z",
    fill: "url(#paint6_linear_921_5748)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_921_5748",
    x1: 145.583,
    y1: 92.6754,
    x2: 47.5424,
    y2: 48.7452,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#40511A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_921_5748",
    x1: 37.9418,
    y1: 156.838,
    x2: 112.243,
    y2: 108.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#17230A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#1B290B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#293B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3F5916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#5E8120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_921_5748",
    x1: 294.364,
    y1: 155.816,
    x2: 97.3533,
    y2: 245.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#3A4B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.291,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_921_5748",
    x1: 262.68,
    y1: 212.675,
    x2: 15.7994,
    y2: 185.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#17230A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#1B290B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#293B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3F5916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#5E8120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_921_5748",
    x1: 122.433,
    y1: 213.03,
    x2: 110.311,
    y2: 141.467,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#17230A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#1B290B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.411,
    stopColor: "#293B0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    stopColor: "#3F5916"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#5E8120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_921_5748",
    x1: 27.4221,
    y1: 156.376,
    x2: 57.2892,
    y2: 156.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.037,
    stopColor: "#8BAE3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.753,
    stopColor: "#658B23"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_921_5748",
    x1: 1249.75,
    y1: 832.33,
    x2: 1336.67,
    y2: 832.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.207,
    stopColor: "white",
    stopOpacity: 0.012
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342,
    stopColor: "white",
    stopOpacity: 0.043
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "white",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "white",
    stopOpacity: 0.188
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.654,
    stopColor: "white",
    stopOpacity: 0.294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    stopColor: "white",
    stopOpacity: 0.427
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.829,
    stopColor: "white",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911,
    stopColor: "white",
    stopOpacity: 0.765
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.987,
    stopColor: "white",
    stopOpacity: 0.965
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_921_5748"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScalelogo);
export default __webpack_public_path__ + "static/media/scale logo.78f78abf43b8015a0b6a84b19353a70a.svg";
export { ForwardRef as ReactComponent };